export const EDUCATION_COPY: any = {
  ACTIVITY_TIMELINE: {
    title: 'Dive into an account’s activity history!',
    body:
      'Use the new activity timeline to get a deeper look at how this account has been previously engaged.',
    imgUrl: 'https://s3.amazonaws.com/driftt-email-assets/ActivityTimelineEducation.png'
  }
}

export const EDUCATION_STORE_NAMES: any = {
  ACTIVITY_TIMELINE: 'prospector.education.activityTimeline'
}
